import { render, staticRenderFns } from "./Wp_video_player.vue?vue&type=template&id=de04a9a2&"
import script from "./Wp_video_player.vue?vue&type=script&lang=js&"
export * from "./Wp_video_player.vue?vue&type=script&lang=js&"
import style0 from "./Wp_video_player.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports